import { atom } from 'recoil';

export const OrderPayload = atom({
    key: 'SAP-ApprovalsOrderPayload',
    default: {
        budgetCode: '',
        costCenterDetails: null,
        ruleName: '',
        ruleRows: [
            {
                ruleType: null,
                value: null,
            },
        ],
        delegateId: null,
        delegateOwner: null,
        delegateOwnerDetails: null,
        startDate: null,
        endDate: null,
        businessJustification: '',
        delegateTitle: '',
    },
});

export const ruleListState = atom({
    key: 'SAP-ruleListState',
    default: [],
});
export const appRuleTypeState = atom({
    key: 'SAP-appRuleType',
    default: { key: '', pageNumber: 1, pageSize: 10 },
});

export const toggleCreateRule = atom({
    key: 'SAP-toggleCreateRule',
    default: { isOpen: false, type: 'create' },
});

export const toggleDeleteRule = atom({
    key: 'SAP-toggleDeleteRule',
    default: {
        isOpen: false,
        type: 'delete',
        message: '',
    },
});

export const isValidCostCenter = atom({
    key: 'approval-isValidCostCenter',
    default: true,
});
export const certCreationRequired = atom({
    key: 'approval-certCreationRequired',
    default: false,
});

export const customDomainFieldsDiasbled = atom({
    key: 'approval-customDomainFieldsDiasbled',
    default: false,
});

export const delegateListState = atom({
    key: 'SAP-delegateListState',
    default: [],
});
export const delegateTypeState = atom({
    key: 'SAP-delegateType',
    default: { key: '', pageNumber: 1, pageSize: 10 },
});

export const toggleCreateDelegate = atom({
    key: 'SAP-toggleCreateDelegate',
    default: { isOpen: false, type: 'create' },
});

export const toggleDeleteDelegate = atom({
    key: 'SAP-toggleDeleteDelegate',
    default: {
        isOpen: false,
        type: 'delete',
        message: '',
    },
});

export const isRuleNameValid = atom({
    key: 'SAP-isRuleNameValid',
    default: true,
});
